import i18n from '@/plugins/i18n';

const { t } = i18n.global;

export default Object.freeze({
  PENDING: { value: 1, color: '#F59E0B', text: t('pending') }, // amber / waiting
  REVIEWING: { value: 2, color: '#ff9f43', text: t('reviewing') }, // info / processing
  APPROVED: { value: 3, color: '#16A34A', text: t('approved') }, // green / success
  REJECTED: { value: 4, color: '#B91C1C', text: t('rejected') }, // dark red
  RECHECKING: { value: 5, color: '#8B5CF6', text: t('rechecking') }, // purple
  CHANGED: { value: 6, color: '#2563EB', text: t('changed') }, // blue
});
